<template>
    <div class="Accordion" :class="{opened}">
        <Button @click="toggleAccordion">
            <h4>{{ title }}</h4>
            <span>+</span>
        </Button>
        <p v-html="description"/>
    </div>
</template>

<script>
export default {
    name: 'Accordion',

    data: () => ({
        opened: false,
    }),

    props: {
        title: { type: String, required: true },
        description: { type: String, required: true },
    },

    methods: {
        toggleAccordion() {
            this.opened = !this.opened;
        },
    },
}
</script>

<style lang="scss" scoped>
@import 'globals.scss';

.Accordion {
    width: 100%;
    background-color: $bg-color-1;

    & + & {
        border-top: 1px solid $divider-color;
    }

    &.opened {
        p {
            display: block;
        }

        span {
            transform: rotate(135deg);
        }

        .Button {
            color: $link-color;
        }
    }

    p {
        margin-bottom: 30px;
        display: none;
    }

    span {
        font-size: 32px;
        font-weight: $font-weight-light;
        transform: rotate(0deg);
        transition: transform 250ms $ease-out;
    }

    .Button {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;
        height: auto;
        padding: 20px 0;
        line-height: 1;
        text-align: left;

        &:hover {
            color: $link-color;
        }
    }
}
</style>
